// Client-safe type definition for AdPlatformMapping
export interface AdPlatformMappingType {
  id?: string
  orgId?: string
  workspaceId?: string
  source?: string
  medium?: string
  platform?: string
}

// [source, medium, platform]
export const defaultAdPlatformMappings = [
  // Google Ads
  [`google`, `cpc`, `Google Ads`],
  [`google`, `ppc`, `Google Ads`],
  [`google`, `cpm`, `Google Ads`],
  [`google`, `paid`, `Google Ads`],
  [`google ads`, `cpc`, `Google Ads`],
  [`google ads`, `ppc`, `Google Ads`],
  [`google ads`, `cpm`, `Google Ads`],
  [`google ads`, `paid`, `Google Ads`],
  [`google`, `display`, `Google Ads`],
  [`google`, `cpm`, `Google Ads`],
  [`google_display`, `display`, `Google Ads`],
  [`google_display`, `cpm`, `Google Ads`],
  [`doubleclick`, `display`, `Google Ads`],
  [`doubleclick`, `cpm`, `Google Ads`],

  // Facebook Ads
  [`facebook`, `cpc`, `Facebook Ads`],
  [`facebook`, `paid social`, `Facebook Ads`],
  [`facebook`, `paid`, `Facebook Ads`],
  [`facebook`, `cpm`, `Facebook Ads`],
  [`facebook`, `ppc`, `Facebook Ads`],
  [`fb`, `cpc`, `Facebook Ads`],
  [`fb`, `paid social`, `Facebook Ads`],
  [`fb`, `paid`, `Facebook Ads`],
  [`fb`, `cpm`, `Facebook Ads`],
  [`fb`, `ppc`, `Facebook Ads`],

  // LSA
  [`google`, `ppl`, `Local Service Ads`],
]

export const defaultAdPlatforms = Array.from(
  new Set(defaultAdPlatformMappings.map(([, , platform]) => platform)),
).sort()
